<template>
	<div class="wrapper">
		<ul class="meter-wrapper">
			<Meter
				class="meter"
				v-for="score in scores"
				:key="score.id"
				v-bind="score"
				v-anchor.group="`ScoreMeter`"
			>
				<MeterChangeAnimation class="meter-change-animation" :scoreId="score.id" />
			</Meter>
		</ul>
		<ul class="savings-wrapper">
			<Savings
				class="meter"
				v-for="fund in funds"
				:key="fund.id"
				v-bind="fund"
				v-anchor.group="`FundTracker`"
			/>
			<InfoPopupToggle
				class="info-popup-toggle"
				:active-component="'SidebarInfoPopup'"
				:button-class="'sidebar-info-btn'"
			>
				i
			</InfoPopupToggle>
		</ul>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import InfoPopupToggle from "@/components/base/InfoPopupToggle";
import MeterChangeAnimation from '@/components/base/MeterChangeAnimation';
import Meter from '@/components/game/sidebar/Meter';
import Savings from '@/components/game/sidebar/Savings';

export default {
	name: 'StatusMeters',
	components: {
		InfoPopupToggle,
		Meter,
		MeterChangeAnimation,
		Savings,
	},
	computed: {
		...mapGetters({
			scores: "game/scores/list",
			funds: "game/funds/list",
		}),
	},
};
</script>

<style lang="scss" scoped>
	.wrapper {
		height: 100%;
		font-family: $body-font-alt-bold;
		font-size: $font-size-xx-sm;
		color: $off-white-dark;
		text-transform: uppercase;
		text-align: center;

		@include tablet { font-size: $font-size-sm; }
		@include desktop { font-size: $font-size-base; }
		@include desktop-sm { font-size: $font-size-sm; }
	}

	.meter-wrapper {
		height: 55%;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		background: $background-color;
		border: $border-width solid $background-color-dark;

		@include mobile { height: 60%; }
	}

	.savings-wrapper {
		height: 45%;
		width: 100%;
		display: flex;
		flex-direction: column;
		justify-content: space-around;
		align-items: center;
		background: $background-color-dark;
		border: $border-width solid $background-color-dark;

		@include mobile {
			height: 40%;

			.meter {
				&:nth-child(2) /deep/ .tooltip {
					bottom: 0;
					top: unset;
				}
			}
		}
	}

	.meter {
		width: 100%;

		&:nth-child(2) /deep/ .floating-change-indicator {
			animation-delay: 1s;
			animation-fill-mode: both;
		}

		&:nth-child(3) /deep/ .floating-change-indicator {
			animation-delay: 2s;
			animation-fill-mode: both;
		}
	}

	.info-popup-toggle {
		@include mobile {
			position: absolute;
			top: 2vw;
			left: 92vw;
			padding: 0 env(safe-area-inset-right) 0 0;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/game/sidebar/StatusMeters.vue